/**
 * Created by jv on 26/01/2017.
 */
const utils = require("Sources/utils/utils");
const Item = require("Sources/models/store/cart-item");

module.exports = class Cart
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.subtotal = options.subtotal;
    this.totalVat = options["total-vat"];
    this.totalPriceVat = options["total-price-with-vat"];
    this.vatList = options["vat-list"];
    this.deliveryCosts = options["delivery-cost"];
    this.discounts = options.discounts;
    this.freeArticles = options["free-articles"];

    this.message = options.message;
    this.valid = options.valid;

    this.items = options["shopping-cart-items"];
  }

  getItemForArticleKey(key)
  {
    for(var i = 0; i < this.items.length; i++)
    {
      var article = this.items[i].article;

      if(utils.isNotNull(article) && article.key === key)
      {
        return this.items[i];
      }
    }

    return null;
  }

  containsArticle(key)
  {
    for(var i = 0; i < this.items.length; i++)
    {
      var article = this.items[i].article;

      if(utils.isNotNull(article) && article.key === key)
      {
        return true;
      }
    }

    return false;
  }

  get itemCount()
  {
    var itemCount = 0;

    for(var i = 0; i < this.items.length; i++)
    {
      itemCount += this.items[i].quantity;
    }

    return itemCount;
  }

  get currency()
  {
    return utils.isNotNull(this._currency) ? this._currency : "€";
  }

  set items(items)
  {
    this._items = [];

    if(utils.isArray(items))
    {
      for(var i = 0; i < items.length; i++)
      {
        this._items.push(new Item(items[i]));
      }
    }
  }

  get items()
  {
    return this._items;
  }

  getItemForKey(key)
  {
    for(var i = 0; i < this.items.length; i++)
    {
      if(this.items[i].article.key === key)
      {
        return this.items[i];
      }
    }

    return null;
  }
};



// WEBPACK FOOTER //
// ./app/js/models/store/cart.js